import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimePickerComponent } from './datetimepicker.component';
import { DateTimePickerModule } from './datetimepicker.module';
/**
 * NgModule definition for the DateTimePicker component with providers.
 */
export class DateTimePickerAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, DateTimePickerModule],
    exports: [
        DateTimePickerModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DateTimePickerAllModule_tsickle_Closure_declarations() {
/** @type {?} */
DateTimePickerAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DateTimePickerAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
